import { render, staticRenderFns } from "./AddLibraryItemsModal.vue?vue&type=template&id=06a27b9e&"
import script from "./AddLibraryItemsModal.vue?vue&type=script&lang=js&"
export * from "./AddLibraryItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports